<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Contacts</h2>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Info</h6>
            </div>
            <div class="table-responsive">
              <div class="section section-service-info">
                <div class="">
                  <div class="service-info">
                    <div class="service-info__preview">
                     <ValidationObserver ref="currencyAddForm" tag="form" class="form-horizontal" id="addNewsForm" @submit.prevent="submit">
                         <div class="form-group">
                           <b-tabs content-class="mt-3">
                             <b-tab :title="language.code" v-for="(language, i) in languages" :key="i">
                               <div class="row mt-3 mr-1 ml-1 d-flex justify-content-between">
                                 <div class="col-md-6 pr-5 pos-relative">
                                   <label class="form-label text-capitalize">Phone</label>
                                   <div class="p-3 phone-group mb-3" style="box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;" v-for="(item, i) in formData.phones" :key="i">
                                     <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                                       <input :id="'name[' + language.code + ']'" class="form-control" :name="'phones['+ i +']title[' + language.code + ']'" :value="item.title[language.code]" :class="checkValidation(classes, language.code)" placeholder="title" type="text">
                                     </ValidationProvider>
                                     <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                                       <input :id="'name[' + language.code + ']'" class="form-control" :name="'phones['+ i +']text[' + language.code + ']'" :value="item.text[language.code]" :class="checkValidation(classes, language.code)" placeholder="text" type="text">
                                     </ValidationProvider>
                                     <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                                       <input :id="'name[' + language.code + ']'" class="form-control" :name="'phones['+ i +']url[' + language.code + ']'" :value="item.url[language.code]" :class="checkValidation(classes, language.code)" placeholder="url" type="text">
                                     </ValidationProvider>
                                   </div>
                                   <button type="button" @click="addPhone" class="btn btn-primary mt-2">
                                     <i class="ti-plus sidemenu-icon"></i>
                                   </button>
                                 </div>
                                 <div class="col-md-6" >
                                   <label class="form-label text-capitalize">Address</label>
                                   <div class="p-3 mb-3" style="box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;" v-for="(item, i) in formData.address" :key="i">
                                     <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                                       <input :id="'name[' + language.code + ']'" class="form-control" :name="'address['+ i +']title[' + language.code + ']'" :value="item.title[language.code]" :class="checkValidation(classes, language.code)" placeholder="title" type="text">
                                     </ValidationProvider>
                                     <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                                       <input :id="'name[' + language.code + ']'" class="form-control" :name="'address['+ i +']text[' + language.code + ']'" :value="item.text[language.code]" :class="checkValidation(classes, language.code)" placeholder="text" type="text">
                                     </ValidationProvider>
                                   </div>
                                   <button type="button" @click="addAddress" class="btn btn-primary mt-2">
                                     <i class="ti-plus sidemenu-icon"></i>
                                   </button>
                                 </div>
                               </div>
                             </b-tab>
                           </b-tabs>
                         </div>
                       <button type="submit" class="btn btn-primary mt-3 mb-5">Submit</button>
                     </ValidationObserver>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'Contacts',
  data () {
    return {
      formData: {
        phones: [
          {
            title: {},
            text: {},
            url: {}
          }
        ],
        address: [
          {
            title: {},
            text: {}
          }
        ]
      },
      upload: false
    }
  },
  computed: {
    ...mapState({
      // settingsList: state => state.contact.settingsList,
      languages: state => state.language.languages
    })
  },
  // created () {
  //   this.getSettingsList().then(() => {
  //     this.formData = this.settingsList
  //   })
  // },
  methods: {
    ...mapActions({
      getSettingsList: 'contact/getSettingsList',
      updateSettings: 'contact/updateSettings'
    }),
    addPhone () {
      this.formData.phones.push({
        title: {},
        text: {},
        url: {}
      })
    },
    addAddress () {
      this.formData.address.push({
        title: {},
        text: {}
      })
    },
    checkValidation (data) {
      return data
    },
    submit () {
      const form = document.getElementById('addNewsForm')
      const formData = new FormData(form)
      this.updateSettings({ data: formData, id: this.formData.id }).then((res) => {
        this.formData = res
        this.$toasted.success('Setting update was successfully!').goAway(1500)
      }).catch(err => {
        if (err && err.response) {
          if (err.response.status === 422) {
            const data = err.response.data.errors
            const keys = Object.keys(data)
            const msg = data[keys[0]]
            this.$toasted.error(msg).goAway(1500)
          } else {
            this.$toasted.error(err.response.message).goAway(1500)
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" >
  .phone-group {
    position: relative;
  }
  .add-button {
    position: absolute;
    right: 0;
    top: 0;
  }

</style>
